import styled, { css } from "styled-components";
import { BackOutlined } from "@assets";

const boxShadowStyle =
  "rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px";
const barColor = css`${props => props.theme.appbarColor}`;

export const Bar = styled.div`
  min-height: 70px;
  padding-inline: 15px 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: ${barColor};
  box-shadow: ${(props) =>
    props.shadow === "hide" ? "none" : boxShadowStyle};
  z-index: 1000;
`;

export const Title = styled.div`
  width: 100%;
  text-align: center;
  color: #F7F7F7;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5;

  @media screen and (max-width: 325px) {
    font-size: 16px;
  }

  @media screen and (max-width: 295px) {
    font-size: 15px;
  }
`;

export const BackIcon = styled(BackOutlined)`
  position: absolute;
  left: 16px;
  font-size: 24px;
  color: #fff;
  cursor: pointer;

  @media screen and (max-width: 325px) {
      width: 24px !important;
  }

  @media screen and (max-width: 295px) {
      width: 23px !important;
  }
`;

export const RightIcon = styled.div`
  position: absolute;
  right: 16px;
  cursor: pointer;

  font-size: 28px;
  color: #fff;

  svg {
    font-size: 28px;
  }

  @media screen and (max-width: 325px) {
    svg {
      width: 24px !important;
    }
  }

  @media screen and (max-width: 295px) {
    svg {
      width: 23px !important;
    }
  }
`;

